import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output, ViewEncapsulation } from '@angular/core';
import { ChipModule } from 'primeng/chip';

@Component({
    selector: 'fcp-chip',
    imports: [CommonModule, ChipModule],
    styleUrl: './fcp-chip.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.data-e2e-hook]': 'e2e()'
    },
    template: `
        <p-chip
            [label]="label()"
            [icon]="icon()"
            [image]="image()"
            [styleClass]="styleClass()"
            [removable]="removable()"
            [removeIcon]="removeIcon()"
            (onRemove)="onRemove.emit({ mouseEvent: $event })"
            (onImageError)="onImageError.emit($event)"
        >
            <ng-content></ng-content>
        </p-chip>
    `
})
export class FcpChipComponent {
    e2e = input<string | null>(null);
    label = input<string>('');
    icon = input<string>('');
    size = input<ChipSize>(ChipSize.Normal);
    image = input<string>('');
    removable = input<boolean>(false);
    removeIcon = input<string>('fc-font-icon fc-font-icon-close');

    onRemove = output<FcpChipRemoveEvent>();
    onImageError = output<Event>();

    styleClass = computed(() => this.size());
}

export enum ChipSize {
    Small = 'small',
    Normal = 'normal'
}

export interface FcpChipRemoveEvent {
    mouseEvent: MouseEvent;
}
